module.exports = __webpack_public_path__ + "img/unit2.b346a7ed.png";